module.exports = require("@swa-ui/application/src/PageMessage/PageMessage.module.scss");